export const AUTH_CODE_FOR_STARTING_WEBINAR = 'AUTH_CODE_FOR_STARTING_WEBINAR';
export const WEBINAR_KEY_FOR_STARTING_WEBINAR = 'WEBINAR_KEY_FOR_STARTING_WEBINAR';
export const SUCCESS_URL_FOR_STARTING_WEBINAR = 'SUCCESS_URL_FOR_STARTING_WEBINAR';
export const MODE_FOR_STARTING_WEBINAR = 'MODE_FOR_STARTING_WEBINAR';
export const REDIRECT_URI_FOR_GOTO_OPENER_AUTH_CODE = `${window.location.protocol}//${window.location.host}/startWebinar`;
